@if (!isInitialized) {
  <div class="container-fluid" >
    <div class="row">
      <div class="col">
        Loading...
      </div>
    </div>
  </div>
}

<p-toast></p-toast>
<app-content-loading>
  @if (!isMaintenance && isInitialized) {
    <div class="app header-fixed sidebar-fixed" [ngClass]="{ 'sidebar-hidden': !showMenu}">
      <div class="app-header">
        @if (showStickyMessages) {
          <app-top-sticky-message-bar></app-top-sticky-message-bar>
        }
        <app-top-navigation></app-top-navigation>
      </div>
      <div class="app-body h-100" [ngClass]="{ 'sticky-message-bar': showStickyMessages }">
        <div class="sidebar">
          <app-side-navigation></app-side-navigation>
        </div>
        <main class="main">
          @if (!isAuthorizationFailed) {
            <div id="router" class="p-2 p-md-5">
              @if (!isAgreementNeeded) {
                <router-outlet></router-outlet>
              }
              @if (isAgreementNeeded) {
                <app-agreement-management></app-agreement-management>
              }
            </div>
          }
          @if (isAuthorizationFailed && !isOdooAccountDisabled) {
            <app-auth-failed></app-auth-failed>
          }
          @if (isAuthorizationFailed && isOdooAccountDisabled) {
            <div class="p-2 p-md-5">
              <app-page-info-message-box
                pageHeader="disabled_account_page_header"
                icon="fa-user-times"
                text="disabled_account_text">
              </app-page-info-message-box>
            </div>
          }
        </main>
      </div>
    </div>
  }
  @if (isMaintenance && isInitialized) {
    <app-maintenance></app-maintenance>
  }
  @if (isInitialized) {
    <app-footer></app-footer>
  }
</app-content-loading>
